/* RK Produkt-Reiter — Umschalten zwischen den Abschnitten.
   Ohne dieses Skript bleiben alle Abschnitte untereinander sichtbar. */
(function () {
  'use strict';

  // Inhalte nicht aktiver Reiter liegen in einem Script-Container und kommen erst beim Öffnen dazu.
  function nachladen(feld) {
    feld.querySelectorAll('script.rk-nachladen').forEach(function (v) {
      var t = document.createElement('template');
      t.innerHTML = v.textContent;
      v.replaceWith(t.content);
    });
  }

  function start(wurzel) {
    var knoepfe = [].slice.call(wurzel.querySelectorAll('[role="tab"]'));
    var felder = [].slice.call(wurzel.querySelectorAll('[role="tabpanel"]'));
    if (knoepfe.length < 2) { felder.forEach(nachladen); return; }

    wurzel.classList.add('ist-bereit');

    function waehlen(i, fokus) {
      knoepfe.forEach(function (k, n) {
        var an = n === i;
        k.classList.toggle('ist-aktiv', an);
        k.setAttribute('aria-selected', String(an));
        k.tabIndex = an ? 0 : -1;
      });
      felder.forEach(function (f, n) {
        f.classList.toggle('ist-aktiv', n === i);
        if (n === i) nachladen(f);
      });
      if (fokus) knoepfe[i].focus();
    }

    knoepfe.forEach(function (k, i) {
      k.addEventListener('click', function () { waehlen(i); });

      // Pfeiltasten, Pos1 und Ende — so erwartet man es bei Reitern.
      k.addEventListener('keydown', function (e) {
        var ziel = null;
        if (e.key === 'ArrowRight') ziel = (i + 1) % knoepfe.length;
        else if (e.key === 'ArrowLeft') ziel = (i - 1 + knoepfe.length) % knoepfe.length;
        else if (e.key === 'Home') ziel = 0;
        else if (e.key === 'End') ziel = knoepfe.length - 1;
        if (ziel !== null) {
          e.preventDefault();
          waehlen(ziel, true);
        }
      });
    });

    waehlen(0);
  }

  function alle() {
    document.querySelectorAll('[data-rk-reiter]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  document.addEventListener('shopify:section:load', alle);
})();
